import { CardParticipantsTabKeyEnum } from '@zaoblako/shared/common/enums/card-participants-tab-key.enum';
import type { CardDescriptorInterface } from '@zaoblako/shared/common/dtos/card/card-descriptor.dto';
import type { CardFieldDescriptorInterface } from '@zaoblako/shared/common/dtos/card/card-field-descriptor.dto';
import type { CardWidgetVisibleWhenInterface } from '@zaoblako/shared/common/dtos/card/card-widget-visible-when.dto';

/** PATCH keys for the participants widget «Участники» tab (roles + auditors). */
export const CARD_PARTICIPANTS_MEMBERS_MUTATION_KEYS: readonly string[] = Object.freeze([
  'createdBy',
  'creator',
  'responsible',
  'externalUser',
  'userAuditors',
  'userGroupAuditors',
  'groupAuditors',
  'externalUserAuditors',
  'auditors'
]);

export const findCardMutationField = (
  descriptor: CardDescriptorInterface | null,
  fieldKey: string
): CardFieldDescriptorInterface | undefined =>
  Object.values(descriptor?.widgets ?? {})
    .flatMap(({ fields }) => fields ?? [])
    .find(({ key }) => key === fieldKey);

export const resolveCardMutationPaths = (
  descriptor: CardDescriptorInterface | null,
  fieldKey: string
): string[] => {
  const field = findCardMutationField(descriptor, fieldKey);
  return [...new Set([fieldKey, ...(field?.mutationAffects ?? [])])];
};

/** Per-row EAV inline save (card requisites additional bridge). */
export const buildEavAttributeMutationPath = (attributeId: number): string => `eavEntity.values.${attributeId}`;

export const isCardMutationPathPending = (pendingPaths: ReadonlySet<string>, path: string | undefined): boolean => {
  if (!path) {
    return false;
  }
  return [...pendingPaths].some((pendingPath) => path === pendingPath || path.startsWith(`${pendingPath}.`) || pendingPath.startsWith(`${path}.`));
};

export const isCardParticipantsTabMutationPending = (pendingPaths: ReadonlySet<string>, tabKey: string): boolean => {
  if (tabKey === CardParticipantsTabKeyEnum.MEMBERS) {
    return CARD_PARTICIPANTS_MEMBERS_MUTATION_KEYS.some((key) => isCardMutationPathPending(pendingPaths, key));
  }
  return false;
};

export const resolveCardVisibleWhenPaths = (
  visibleWhen: CardWidgetVisibleWhenInterface | undefined
): string[] => {
  if (!visibleWhen) {
    return [];
  }
  if ('entityPath' in visibleWhen) {
    return [visibleWhen.entityPath];
  }
  return visibleWhen.and.flatMap(resolveCardVisibleWhenPaths);
};
